/**
 * Blocks opening an inbox report when the owning facility is far enough in arrears. Allows the report unless the facility's arrears level is 50 or 60, and even then allows already-read reports and urgent or emergent event and notification reports.
 *
 * @param clickedReport - Inbox report the user clicked.
 * @returns True when the report must not be opened.
 */
const isNotAllowedViewReport = (clickedReport: any) => {
  const { type, isRead, priority, facility } = clickedReport;
  if (!['50', '60'].includes(facility.arrears.toString())) {
    return false;
  }
  if (isRead) {
    return false;
  }
  if ((type === 'Event' || type === 'Notification') && ['Urgent', 'Emergent'].includes(priority)) {
    return false;
  }
  return true;
};

export { isNotAllowedViewReport };
